import { useState } from 'react';
import { Group } from '../../components/types';

export function useHistory(groups: Group[]) {
  const [history, setHistory] = useState<Group[][]>([]);
  const [redoStack, setRedoStack] = useState<Group[][]>([]);

  const saveToHistory = () => {
    setHistory((prev) => [...prev, JSON.parse(JSON.stringify(groups))]);
    setRedoStack([]);
  };

  const undo = (): Group[] | null => {
    if (history.length === 0) return null;

    const previousState = history[history.length - 1];
    if (!previousState) return null;

    setRedoStack((prev) => [...prev, JSON.parse(JSON.stringify(groups))]);
    setHistory((prev) => prev.slice(0, -1));
    return previousState;
  };

  const redo = (): Group[] | null => {
    if (redoStack.length === 0) return null;

    const nextState = redoStack[redoStack.length - 1];
    if (!nextState) return null;

    setHistory((prev) => [...prev, JSON.parse(JSON.stringify(groups))]);
    setRedoStack((prev) => prev.slice(0, -1));
    return nextState;
  };

  const canUndo = history.length > 0;
  const canRedo = redoStack.length > 0;

  return {
    saveToHistory,
    undo,
    redo,
    canUndo,
    canRedo,
  };
}
